import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ListStore = {
  selections: Record<string, boolean>;
  setSelection: (settingKey: string, value: boolean) => void;
};

export const useListStore = create<ListStore>()(
  persist(
    (set) => ({
      selections: {},
      setSelection: (settingKey, value) =>
        set((state) => ({
          selections: { ...state.selections, [settingKey]: value },
        })),
    }),
    {
      name: "list-settings-store",
    },
  ),
);
